<template>
<div class="text-content-section">
    <h3>Top searches</h3>

    <ul class="list-group w-50">
        <li class="list-group-item d-flex justify-content-between align-items-center" v-for="(item, index) in searches" :key="index" :value="item">
            {{ item.Text }}
            <span class="badge badge-primary badge-pill">{{ item.Count }}</span>
        </li>
    </ul>
</div>
</template>

<style>
</style>

<script>
/* eslint-disable */
import axios from 'axios';

export default {
    data() {
        return {
            searches: [],
        }
    },
    mounted: function() {
        this.loadSearchLog();
    },
    methods: {
        loadSearchLog: function() {
            const vm = this;
            axios.post('/api/searches/100', { text: null }).then(response => {
                vm.searches = response.data;
            }).catch(error => { 
                vm.searches = [];
            });
        }
    }
}
</script>